import { Direction } from "../../constants/Direction";
import { Filter } from "../../models/Filter";
import { MultiSelectOption } from "../../models/MultiSelectOption";
import { SearchTerm } from "../../models/search/SearchTerm";
import { SortBy } from "../../models/SortBy";

export const getSortByClause = (sortBy: SortBy | undefined) => {

    if (!sortBy || !(sortBy.columnName)) {
        return '';
    }
    else if (sortBy.direction === Direction.ascending) {
        return '&sort=' + sortBy.columnName;
    }

    return '&sort=-' + sortBy.columnName;
}

/**
 * Helper function to append a filter to a filter string. 
 * If the filter string already contains a filter, it will append the filter with a semicolon.
 * Otherwise, it will append the filter with a filter= prefix.
 * @param filterString 
 * @param filterToAppend 
 * @returns 
 */
export const appendFilterString = (filterString?: string, filterToAppend?: string) => {
    let combinedFilter;

    if (filterString?.includes('&filter')) {
        combinedFilter = filterString + ';' + filterToAppend;
    }
    else {
        combinedFilter = '&filter=' + filterToAppend;
    }

    return combinedFilter;
}

// TODO - Move the alternative key to the filter object. Not doing it now as this might affect other parts of the code.
export const getFilterClause = (filters?: Filter[], searchTerm?: SearchTerm, altDateKey?: string) => {
    let reducedFilters: string[] = [];
    const dateFilter = filters?.find(filter => filter.key === "dateOnly");

    if (dateFilter) {
        const dates: string[] = dateFilter.selected[0].value.includes(';') ? dateFilter.selected[0].value.split(';') : [dateFilter.selected[0].value];
        const dateKey = altDateKey ? altDateKey : "dateOnly";

        dates.length > 1 ?
            reducedFilters.push(`${dateKey}=ge='${dates[0].trim()}';${dateKey}=le='${dates[1].trim()}U'`) // The U only on the 
            : reducedFilters.push(`${dateKey}=ge='${dates[0].trim()}';${dateKey}=le='${dates[0].trim()}U'`)
    }

    if (filters
        && filters.length > 0
        && filters.some(filter => filter.selected && filter.selected.length > 0)) {

        filters.forEach((filter) => {
            if (filter.key === dateFilter?.key) {
                return;
            }

            const filterNotBeingIgnored: MultiSelectOption[] = filter.selected?.filter(selected => selected.ignore !== true);
            const filterStringFormetted = filterNotBeingIgnored?.map(selected => selected.value).join(',');
            
            if (filterStringFormetted) {
                reducedFilters.push(`${filter.key}${filter.operator ? filter.operator : '=in='}(${filterStringFormetted})`);
            }
        });
    }

    const isSearchTermValid = searchTerm?.accessor && searchTerm?.value;
    const quotationMark = searchTerm?.value?.includes('"') ? "'" : '"';
    const newSearchValue = searchTerm?.value?.replace(/%/g, '%25').replace(/#/g, '%23').replace(/&/g, '%26');

    return reducedFilters.length > 0 || isSearchTermValid
        ? `&filter=${reducedFilters.join(';')}${(reducedFilters.length > 0 && isSearchTermValid) ? ';' : ''}${isSearchTermValid ? searchTerm?.accessor + `=ini=${quotationMark}*` + newSearchValue + `*${quotationMark}` : ''}`
        : '';
}

/**
 * 
 * @param goToPage - page number to be navigated to
 * @param pageSize - number of items to be displayed per page
 * @param sortBy - sort by clause to be applied to the query
 * @param filters - filters to be applied to the query
 * @param defaultSortBy -- if no sortBy is provided, this will be used  
 * @returns - a partial URL to be appended to the base URL
 */
export const createPartialURL = (goToPage?: number, pageSize?: number, sortBy?: SortBy, filters?: string, defaultSortBy?: string): string => {
    const goToPageNumber = !goToPage ? '' : '&page[number]=' + goToPage;
    const withPageSize = !pageSize ? '' : '&page[size]=' + pageSize;
    let withSortBy = getSortByClause(sortBy);
    withSortBy = !withSortBy && defaultSortBy ? '&sort=' + defaultSortBy : withSortBy;
    filters = !filters ? '' : filters;

    return `&page[totals]${goToPageNumber}${withPageSize}${withSortBy}${filters}`
}
